document.addEventListener("DOMContentLoaded", () => {
  const newCollection = [
    {
      id: "Slide-template--19545056739612__82b08fe2-2d95-4757-8abe-6557fa29803b-2",
      image:
        "https://hartansh.com/cdn/shop/files/Artboard31_fb45488f-b78e-40b3-b4ce-2fdb5daa3a45.png?v=1713775990&width=1946",
      linkText: "Achkan",
    },
    // {
    //   id: "Slide-template--22699861246236__82b08fe2-2d95-4757-8abe-6557fa29803b-3",
    //   image:
    //     "https://hartansh.com/cdn/shop/files/Artboard13_5dbc2fe7-f6d6-4b8f-a440-9e96b0f13603.png?v=1713532224&width=1946",
    //   linkText: "Royal Thread",
    // },
    {
      id: "Slide-template--19545056739612__82b08fe2-2d95-4757-8abe-6557fa29803b-4",
      image:
        "https://hartansh.com/cdn/shop/files/Artboard29_ae730784-0a59-43fa-8c88-aaf0510a06ac.png?v=1713529138&width=1946",
      linkText: "Embroidered Jacket",
    },
  ];

  const changeImages = (array) => {
    array.forEach((collection) => {
      const sS24 = document.getElementById(collection.id);
      const sS24Image = sS24.querySelector("img");
      const sS24Text = sS24.querySelectorAll(".full-unstyled-link");
      console.log(collection);
      sS24Image.src = collection.image;
      sS24Image.setAttribute("srcset", "");
      sS24Text[1].innerHTML = `${collection.linkText} 
      <span class="icon-wrap"><svg
        viewBox="0 0 14 10"
        fill="none"
        aria-hidden="true"
        focusable="false"
        class="icon icon-arrow"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z"
          fill="currentColor"
        ></path>
      </svg>
    </span>`;
    });
  };

  changeImages(newCollection);

  const clientsTestimonials = [
    "https://cdn.shopify.com/s/files/1/0761/7616/3100/files/WhatsApp_Image_2024-06-19_at_5.33.02_PM_430x.jpg?v=1718799581",
    "https://cdn.shopify.com/s/files/1/0761/7616/3100/files/28.png?v=1735562961",
    "https://cdn.shopify.com/s/files/1/0761/7616/3100/files/423693573_17886614801992056_8065613972276682587_n_430x.jpg?v=1718882833",
    "https://cdn.shopify.com/s/files/1/0761/7616/3100/files/HARTANSH_TEST._SR.jpg?v=1748347701",
        "https://cdn.shopify.com/s/files/1/0761/7616/3100/files/28.jpg?v=1750244146",

    "https://cdn.shopify.com/s/files/1/0761/7616/3100/files/WhatsApp_Image_2024-06-19_at_5.33.03_PM_430x.jpg?v=1718799581",
    "https://cdn.shopify.com/s/files/1/0761/7616/3100/files/31.png?v=1735562961",
    "https://cdn.shopify.com/s/files/1/0761/7616/3100/files/428666504_17889176363992056_2772322630670794053_n_430x.jpg?v=1718882834",
    "https://cdn.shopify.com/s/files/1/0761/7616/3100/files/HARTANSH_TEST._ar.jpg?v=1748347701",
    "https://cdn.shopify.com/s/files/1/0761/7616/3100/files/WhatsApp_Image_2024-06-19_at_5.33.04_PM_430x.jpg?v=1718799582",
    "https://cdn.shopify.com/s/files/1/0761/7616/3100/files/27.png?v=1735562961",
    "https://cdn.shopify.com/s/files/1/0761/7616/3100/files/412130004_17881226711992056_1358230259208072558_n_430x.jpg?v=1718964218",
    "https://cdn.shopify.com/s/files/1/0761/7616/3100/files/WhatsApp_Image_2025-05-27_at_12.25.03_e381f224.jpg?v=1748347700",
    "https://cdn.shopify.com/s/files/1/0761/7616/3100/files/27.jpg?v=1750244146",
  ];

  const slideWrapper = document.querySelector(".swiper-container .swiper-wrapper");

  clientsTestimonials.forEach((item) => {
    let slide = document.createElement("div");
    slide.classList.add("swiper-slide");
    slide.innerHTML = `<img src="${item}" alt="Hartansh Happy Clients" loading="lazy">`;
    slideWrapper.appendChild(slide);
  });

   var swiper = new Swiper(".swiper-container", {
        spaceBetween: 20,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".btn_wrapper .next_btn",
          prevEl: ".btn_wrapper .prev_btn",
        },
        breakpoints: {
          1200: {
            slidesPerView: 5,
          },
          1024: {
            slidesPerView: 4,
          },
          767: {
            slidesPerView: 3,
          },
          480: {
            slidesPerView: 2,
          },
        },
      });
  
});
